import React from 'react';
export const EmptyPolicies = (): JSX.Element => (
  <div className="empty-policies">
    <div className="empty-title">
      <h1>YOUR POLICY CONTENTS WILL GO HERE</h1>
    </div>
    <div className="empty-content">
      <p>
        Start by adding a new policy on the left and give your policy a name. Popular ideas include
        a club policy, tournment policy, local course rules, and awards polices. Create as many as
        you like. Then you can add, revise, or remove the policy details in this area. Players will
        be able to find them in the Club Info section of their app.
      </p>
    </div>
  </div>
);
